const ActiveTabsTypes = {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  REMOVE_ACTIVE_TAB: 'REMOVE_ACTIVE_TAB',
  SHOW_MODAL: 'SHOW_MODAL',
  MODAL_ACTION: 'MODAL_ACTION',
};

export default ActiveTabsTypes;
